import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal} from '../../../../shared/reducers/modals';
import {Checkbox, LoadingSpinner} from '../../../../shared';
import Table from '../../../../shared/components/Table';
import debug from 'debug';
import {gatherData, getUpdatedFilter} from '../../../../shared/utils/utils';
import useQueryObject from '../../../../shared/utils/useQueryObject';
import {isEntitled} from '../../../../shared/reducers/user';
import {withSize} from 'react-sizeme';

const log = debug('circleblack:advisor:analyze:branches:table');

const BranchesTable = ({container, onRowClick, rowOnClickDisabled, maxHeight, size}) => {
  const [filters, setFilters] = useQueryObject('branchTableFilters', {}); // ETODO Think about table filters and how they work, like using a suffix?
  const gatherBranches = container && gatherData(`/containers/${container.id}/branches`);

  const dataManager = {
    gatherData: inputValue => gatherBranches({...inputValue, ...getUpdatedFilter(filters)}),
  };

  React.useEffect(() => {
    if (dataManager.refresh) {
      dataManager.refresh();
    }
  }, [container, filters]);

  const updateFilters = (name, value) => setFilters({...filters, [name]: value});

  log('rendering');

  if (!container) {
    return <LoadingSpinner/>;
  }

  // ETODO Reqs considering hiding columns with sizing

  return <Table dataManager={dataManager}
                columns={[
                  {
                    title: 'Branch',
                    dataPoint: 'name',
                    type: 'text',
                    minWidth: 120,
                    isSortable: true,
                  },
                  isEntitled([{group: 'advisor', feature: 'primaryCode', access: 'r'}]) && {
                    title: 'Branch Code',
                    dataPoint: 'primaryBranchCode',
                    type: 'text',
                    minWidth: 60,
                    isSortable: true,
                  },
                  size.width > 400 && {
                    title: 'Advisors',
                    dataPoint: 'counts.advisors.total',
                    type: 'number',
                    minWidth: 80,
                    isSortable: false,
                  },
                  size.width > 400 && {
                    title: 'Households',
                    dataPoint: 'counts.clients.total',
                    type: 'number',
                    minWidth: 80,
                    isSortable: false,
                  },
                  {
                    title: 'Total Assets',
                    dataPoint: 'amount',
                    type: 'currency',
                    minWidth: 80,
                    isSortable: true,
                  },
                ].filter(c => !!c)}
                defaultSort={{
                  column: 'name',
                  desc: false,
                }}
                searches={[
                  {
                    title: 'Branch Name',
                    name: 'name',
                    isFuzzy: true,
                  },
                  isEntitled([{group: 'advisor', feature: 'primaryCode', access: 'r'}]) && {
                    title: 'Branch Code',
                    name: 'primaryBranchCode',
                    isFuzzy: true,
                  },
                ].filter(s => !!s)}
                rowIdentifier={'id'}
                rowOnClick={onRowClick}
                rowOnClickDisabled={rowOnClickDisabled}
                iconsKey={[
                  {
                    image: 'dotNew',
                    title: 'Is New',
                    color: '#00D0BE',
                    description: 'Indicates New Branch',
                    displayCondition: a => !!a.isNew,
                  },
                ]}
                filters={[
                  <Checkbox
                    key={'isNew'}
                    title={'New'}
                    dataPoint={{
                      name: 'isNew',
                      value: !!filters.isNew,
                    }}
                    onChange={(name, value) => updateFilters(name, value || undefined)}
                    disabled={false}/>,
                ].filter(f => !!f)}
                maxHeight={maxHeight}
                filterValues={filters}/>;
};

const mapStateToProps = state => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default compose(withSize(), connect(mapStateToProps, mapDispatchToProps))(BranchesTable);

BranchesTable.propTypes = {
  /**
   * SizeMe size
   */
  size: PropTypes.shape({
    width: PropTypes.number,
  }),
  openModal: PropTypes.func.isRequired,
  container: PropTypes.shape({id: PropTypes.number.isRequired, type: PropTypes.string.isRequired}).isRequired,
  /**
   * Optional on row click action
   */
  onRowClick: PropTypes.func,
  /**
   * Optional on row click disabled
   */
  rowOnClickDisabled: PropTypes.func,
  /**
   * Optional max height of table
   */
  maxHeight: PropTypes.number,
};
